export { default } from './SplatnostForm';
